(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p123-home-newest"] && !Shopify.designMode) return;
  try {
    
function initializeNewest(root) {
  if(root.dataset.ready) return;
  root.dataset.ready='true';
  var track=root.querySelector('.p123-newest-track');
  var prev=root.querySelector('[data-newest-prev]');
  var next=root.querySelector('[data-newest-next]');
  function sync(){prev.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;}
  function move(direction){track.scrollBy({left:direction*(track.clientWidth+18),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
  prev.addEventListener('click',function(){move(-1);});next.addEventListener('click',function(){move(1);});
  track.addEventListener('scroll',sync,{passive:true});window.addEventListener('resize',sync);sync();
  function loadNewest(){
  var controller=new AbortController();var timeout=setTimeout(function(){controller.abort();},8000);
  fetch(root.dataset.source,{signal:controller.signal}).then(function(r){if(!r.ok)throw new Error('newest');return r.text();}).then(function(html){var doc=new DOMParser().parseFromString(html,'text/html');var cards=doc.querySelector('[data-p123-newest-cards]');if(cards&&cards.querySelector('.p123-h-card')){track.replaceChildren.apply(track,Array.from(cards.children));sync();}}).catch(function(){}).finally(function(){clearTimeout(timeout);});
  }
  if('IntersectionObserver' in window){var observer=new IntersectionObserver(function(entries){if(entries.some(function(entry){return entry.isIntersecting;})){observer.disconnect();loadNewest();}},{rootMargin:'800px 0px'});observer.observe(root);}else{loadNewest();}
}
function initializeNewestSections(){document.querySelectorAll('[data-p123-newest]').forEach(initializeNewest);}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initializeNewestSections,{once:true});}else{initializeNewestSections();}
document.addEventListener('shopify:section:load',initializeNewestSections);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-page-tab"]) return;
  try {
    

document.addEventListener('click', function(event) {
  var button = event.target.closest('.p123-description-toggle');
  if (!button) return;
  var content = document.getElementById(button.getAttribute('aria-controls'));
  if (!content) return;
  var expanded = button.getAttribute('aria-expanded') === 'true';
  button.setAttribute('aria-expanded', String(!expanded));
  content.hidden = expanded;
  button.closest('.tab-panel').classList.toggle('active', !expanded);
  button.querySelector('i').className = expanded ? 'icon-plus' : 'icon-minus';
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-recently-viewed"]) return;
  try {
    
function p123LoadRecent(root) {
  root.querySelectorAll('[data-p123-recent-products]').forEach(function(section) {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';
    var current = section.dataset.currentHandle;
    var handles = [];
    try {
      var saved = JSON.parse(localStorage.getItem('product-recent') || '[]');
      if (Array.isArray(saved)) handles = saved.filter(function(handle) { return typeof handle === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(handle); });
      handles = Array.from(new Set(handles)).filter(function(handle) { return handle !== current; });
      localStorage.setItem('product-recent', JSON.stringify([current].concat(handles).slice(0, 10)));
    } catch (error) { return; }
    var recentHandles = handles.slice(0, 4);
    if (!recentHandles.length) return;
    Promise.all(recentHandles.map(function(handle) {
      return fetch(section.dataset.cardBase + 'products/' + encodeURIComponent(handle) + '?view=p123_card', { credentials: 'same-origin' })
        .then(function(response) { if (!response.ok) return null; return response.text(); })
        .then(function(html) {
          if (!html) return null;
          return new DOMParser().parseFromString(html, 'text/html').querySelector('.p123-h-card');
        }).catch(function() { return null; });
    })).then(function(cards) {
      if (!section.isConnected) return;
      var grid = section.querySelector('.p123-product-suggestions__grid');
      cards.forEach(function(card) { if (card) grid.appendChild(card); });
      if (grid.children.length) section.hidden = false;
    });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { p123LoadRecent(document); }, { once: true });
} else { p123LoadRecent(document); }
document.addEventListener('shopify:section:load', function(event) { p123LoadRecent(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
    jQuery(document).ready(function ($) {
        $('.btn-close').on('click', function(){
        $(this).parents('.parent-close').slideUp();
        })
    });

  } catch(e) { console.error(e); }
})();
})();
